import React, { useState } from 'react';
import {
  string, arrayOf, shape, func
} from 'prop-types';
import { Col, Row, Tabs, Tab } from '@thd-olt-component-react/core-ui';

const VisualTabs = (props) => {
  const { categories, products, filterItemIds } = props;
  const [value, setValue] = useState(0);
  const onChange = ({ index }) => {
    setValue(index);
  };

  let productItemIds;
  if (products?.length > 0) {
    productItemIds = products?.map((product) => product?.product?.itemId);
  }

  let categoryProducts;
  const setCategoriesIds = (itemIds) => {
    categoryProducts = products?.filter((product) => itemIds.includes(product?.product?.itemId));
    filterItemIds(categoryProducts);
  };

  let tabCategories = [];
  let allItemsCategory;

  allItemsCategory = {
    subCategory: 'All Items',
    itemIds: productItemIds
  };

  tabCategories.push(allItemsCategory);

  categories.forEach((category) => {
    tabCategories.push({
      subCategory: `${category.category}`,
      itemIds: category.itemIds
    });
  });

  return (
    <Row>
      <Col>
        <Tabs gridStyle value={value} onChange={onChange}>
          {tabCategories?.map((category, idx) => {
            return (
              <Tab label={category.subCategory} key={idx} onClick={() => { setCategoriesIds(category.itemIds); }} />
            );
          })}
        </Tabs>
      </Col>
    </Row>
  );
};

VisualTabs.propTypes = {
  categories: arrayOf(shape({
    category: string,
    itemIds: arrayOf
  })),
  products: arrayOf(shape({
    product: shape({
      itemId: string
    })
  })),
  filterItemIds: func
};

VisualTabs.defaultProps = {
  categories: {
    category: null,
    itemIds: null,
    products: null
  },
  products: {
    product: {
      itemId: null
    }
  },
  filterItemIds: null
};

export default VisualTabs;
